<template>
  <div class="w-100">
    <input type="text" :value="getSelectedText" id="clipboardText" class="d-none" />
    <div
      v-show="showMenu && selectedText"
      class="menu"
      :style="{
        left: `${x}px`,
        top: `${y}px`,
      }"
      @mousedown.prevent=""
    >
      <span class="item">
        <ShareNetwork
          network="facebook"
          :url="urlShared"
          :title="trans('streams.sharing.title')"
          :quote="getTextToShare(322)"
          hashtags="lifeed"
          @open="trackAction"
        >
          <icon
            path="social"
            name="facebook"
            extension="svg"
            classes=""
            sizeWidth="15px"
            sizeHeight="15px"
            opacity="1"
          />
        </ShareNetwork>
      </span>
      <span class="item">
        <ShareNetwork
          network="twitter"
          :url="urlShared"
          :title="getTextToShare(193)"
          hashtags="lifeed"
          @open="trackAction"
        >
          <icon
            path="social"
            name="twitter"
            extension="svg"
            classes=""
            sizeWidth="15px"
            sizeHeight="15px"
            opacity="1"
          />
        </ShareNetwork>
      </span>
      <span class="item" @click="copyClipboard">
        <icon
          path="social"
          name="copy-to-clipboard"
          extension="svg"
          classes=""
          sizeWidth="15px"
          sizeHeight="154px"
          opacity="1"
        />
      </span>
    </div>

    <slot />
  </div>
</template>

<script>
import Icon from "../atoms/Icon";

export default {
  name: "Highlightable",
  components: { Icon },
  data() {
    return {
      x: 0,
      y: 0,
      showMenu: false,
      selectedText: "",
      urlShared: this.trans("streams.sharing.cta_link"),
    };
  },
  computed: {
    highlightableEl() {
      return this.$slots.default[0].elm;
    },
    getSelectedText: function () {
      return this.selectedText.replace(/^\s+|\s+$/g, "");
    },
  },
  mounted() {
    window.addEventListener("mouseup", this.onMouseup);
  },

  beforeDestroy() {
    window.removeEventListener("mouseup", this.onMouseup);
  },

  methods: {
    getTextToShare(length) {
      let selectedTextLength = this.getSelectedText.length;
      if (selectedTextLength > length)
        return `"${this.getSelectedText.slice(0, length)}..." - ${this.trans(
          "streams.sharing.subtitle"
        )}`;
      else if (selectedTextLength > 70)
        return `"${this.getSelectedText}" - ${this.trans("streams.sharing.subtitle")}`;

      return `"${this.getSelectedText}" - ${this.trans("streams.sharing.subtitle")}\n\n${this.trans(
        "streams.sharing.description"
      )}`;
    },
    onMouseup() {
      const selection = window.getSelection();
      if (selection.rangeCount) {
        const selectionRange = selection.getRangeAt(0);

        const startNode = selectionRange.startContainer.parentNode;
        const endNode = selectionRange.endContainer.parentNode;

        if (!startNode.isSameNode(this.highlightableEl) || !startNode.isSameNode(endNode)) {
          this.showMenu = false;
        }

        const { x, y, width } = selectionRange.getBoundingClientRect();
        if (!width) {
          this.showMenu = false;
          return;
        }
        this.x = x + width / 2;
        this.y = y + window.scrollY - 10;

        //set timeout to prevent blinking on click outsite of selection
        setTimeout(() => {
          this.selectedText = selection.toString();
          this.showMenu = true;
        }, 100);
      }
    },
    makeToast() {
      this.$bvToast.toast(`${this.trans("streams.copy_to_clipboard")}`, {
        autoHideDelay: 3000,
      });
    },
    copyClipboard() {
      var copyText = document.getElementById("clipboardText");
      copyText.classList.remove("d-none");
      copyText.select();
      document.execCommand("copy");
      copyText.classList.add("d-none");
      this.showMenu = false;
      this.makeToast();
      this.trackAction("copy");
    },
    trackAction(network) {
      trackEvent("StreamElementTextShare", {
        elementType: "miu",
        miuId: this.$route.params.elementId,
        streamId: this.$route.params.id,
        action: network,
      });
    },
  },
  watch: {
    selectedText: function (val) {
      if (val) {
        this.trackAction("textSelection");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.menu {
  height: 30px;
  padding: 5px 10px;
  background: $color-dark;
  border-radius: 3px;
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -100%);
  transition: 0.2s all;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  &:after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -5px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid $color-dark;
  }
}
.item {
  color: $color-white;
  cursor: pointer;

  &:hover {
    color: $color-blue;
  }
  & + .item {
    margin-left: 10px;
  }
}
</style>
